module.exports = __webpack_public_path__ + "static/img/thai-nguyen-GDhwLYdJUio-unsplash_thumb.1900e4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/thai-nguyen-GDhwLYdJUio-unsplash_thumb.png
// module id = GyyO
// module chunks = 4